interface AboutValuationType {
  ariaLabel: string;
  title: string;
  content: string[];
  checklist: string[];
}

const About: AboutValuationType = {
  ariaLabel: 'Information om hur värderingen fungerar',
  title: 'Värdera bilen gratis',
  content: [
    'Med ditt registeringsnummer har vi hämtat ett flertal uppgifter om din bil. Ange bara bilens miltal och skick så får du kostnadsfritt ett uppskattat inköpspris av din bil.',
    'Vill du också sälja bilen kan du enkelt fylla i dina kontaktuppgifter så hör vi av oss till dig.',
  ],
  checklist: [
    'Värderingen är helt kostnadsfri',
    'Du väljer själv om du vill sälja bilen – och binder dig inte till något',
  ],
};

const AboutValuation = `
<section class="waykevaluation-page-section" aria-label="${About.ariaLabel}">
  <div class="waykevaluation-stack waykevaluation-stack--3">
    <h3 class="waykevaluation-heading waykevaluation-heading--3">${About.title}</h3>
    <div class="waykevaluation-content">
      ${About.content
        .map((content) => `<p class="waykevaluation-content__p">${content}</p>`)
        .join('')}
    </div>
  </div>
  <div class="waykevaluation-stack waykevaluation-stack--3">
    <div class="waykevaluation-balloon">
      <ul class="waykevaluation-checklist">
      ${About.checklist
        .map((checklist) => `<li class="waykevaluation-checklist__item">${checklist}</li>`)
        .join('')}
      </ul>
    </div>
  </div>
</section>
`;

export default AboutValuation;
